import React, { useState } from 'react';
import { Box, Divider } from '@material-ui/core';
import { useLocation } from 'react-router-dom';

import DetailInformation from './DetailInformation';
import TicketSelector from './TicketSelector';
import { useTicketDetailViewStyles } from './styles';

const TicketDetailView = () => {
  const location = useLocation();
  const { ticket, tickets } = location.state;
  const classes = useTicketDetailViewStyles();
  const [ticketSelected, setTicketSelected] = useState('');

  const handleSelectedTicket = (eventTicket) => {
    setTicketSelected(eventTicket);
  };

  return (
    <Box
      padding="0px 30px"
      marginTop="28px"
      display="flex"
      flexDirection="column"
      width="100%"
    >
      <DetailInformation ticket={ticket} ticketSelected={ticketSelected} />
      <Divider className={classes.divider} />
      <TicketSelector tickets={tickets} onSelect={handleSelectedTicket} />
      <Divider className={classes.divider} />
    </Box>
  );
};

export default TicketDetailView;
